import { render } from "./ArrowDown.vue?vue&type=template&id=ade0139c&scoped=true"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"

import "./ArrowDown.vue?vue&type=style&index=0&id=ade0139c&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade0139c"]])

export default __exports__